import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30e30327"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sheet-input-base-checkbox" }

import { ref, withDefaults, watch } from 'vue'

// TODO: 型定義が複数箇所にあるので見直し
interface Props {
  value: string
  label: string
  readonly?: boolean

  modelValue: string | null
}


export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    label: null,
    readonly: { type: Boolean, default: false },
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { value: string, label: string, readonly: boolean, modelValue: string | null }





const innerModelValue = ref<string[]>([])

watch(
  () => props.modelValue,
  () => {
    innerModelValue.value = props.modelValue?.split(',') ?? []
  },
)

watch(
  innerModelValue,
  () => {
    emit('update:modelValue', innerModelValue.value.join(','))
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_field = _resolveComponent("q-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_field, {
      outlined: "",
      dense: "",
      class: _normalizeClass(["cursor-pointer", { 'bg-grey-4': props.readonly }])
    }, {
      control: _withCtx(() => [
        _createVNode(_component_q_checkbox, {
          dense: "",
          label: __props.label,
          val: __props.value,
          disable: __props.readonly,
          class: "full-width",
          modelValue: innerModelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerModelValue).value = $event))
        }, null, 8, ["label", "val", "disable", "modelValue"])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})